/* eslint-disable no-restricted-syntax */
import { getHTMLDocument } from 'core/includes/html/utils/dom';
import { getPluginByName } from './get-plugin';

export default async function executePlugin(elHTML: string, pluginsDocument: any) {
  const htmlDoc = getHTMLDocument(elHTML);
  const plugins = htmlDoc.querySelectorAll('plugin');

  // @ts-ignore
  const pluginsArray = [...plugins];

  for (const pluginEl of pluginsArray) {
    const { innerHTML: name } = pluginEl;
    // @ts-ignore
    const plugin = getPluginByName(name);

    if (plugin?.call) {
      try {
        // eslint-disable-next-line no-await-in-loop
        const result = await plugin.call(elHTML, pluginsDocument);
        pluginEl.outerHTML = result;
      } catch (error) {
        console.error(error);
        pluginEl.outerHTML = '';
      }
    }
  }

  return htmlDoc.body.innerHTML;
}
